var map = {
	"./ic_baogaojiedu.svg": "30f2",
	"./ic_baogaojiedu_dis.svg": "cf95",
	"./ic_liquan.svg": "e670",
	"./ic_liquan_dis.svg": "84ed",
	"./ic_manjianquan.svg": "cd54",
	"./ic_manjianquan_dis.svg": "c049",
	"./ic_tijianyuyue.svg": "34e7",
	"./ic_tijianyuyue_dis.svg": "a42f",
	"./ic_tishi.svg": "6b98",
	"./ic_zaixianwenzheng.svg": "0144",
	"./ic_zaixianwenzheng_dis.svg": "9e73",
	"./icon_arrow_rig.svg": "3915",
	"./icon_arrow_rig_gray.svg": "f3c8",
	"./icon_arrow_rig_zx.svg": "7513",
	"./icon_arrow_right.svg": "03fc",
	"./icon_pay_success.svg": "5fa9",
	"./loading-dot.svg": "0067",
	"./tabbar_icon_examination_def.svg": "d316",
	"./tabbar_icon_examination_nucleic_acid.svg": "17c5",
	"./tabbar_icon_examination_sel.svg": "7639",
	"./tabbar_icon_examination_zx_def.svg": "63f2",
	"./tabbar_icon_examination_zx_sel.svg": "801e",
	"./tabbar_icon_home_def.svg": "9afe",
	"./tabbar_icon_home_examination_def.svg": "2296",
	"./tabbar_icon_home_examination_sel.svg": "92f0",
	"./tabbar_icon_home_sel.svg": "59de",
	"./tabbar_icon_home_zx_def.svg": "9003f",
	"./tabbar_icon_home_zx_sel.svg": "db4b",
	"./tabbar_icon_mine_def.svg": "3f66",
	"./tabbar_icon_mine_sel.svg": "095b",
	"./tabbar_icon_mine_zx_def.svg": "bc53",
	"./tabbar_icon_mine_zx_sel.svg": "485a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";